// Canonical list of job positions.
// Must stay in sync with:
//   - ChulasBackend/handlers/jobs/submit_application.py (POSITION_TYPE_MAP)
//   - ChulasBackend/handlers/admin/update_settings.py (VALID_POSITIONS)
//   - applyform/public/index.html (checkbox values)
export const VALID_POSITIONS = [
  'Floor Manager',
  'Host / Hostess',
  'Server',
  'Bartender',
  'Food Runner',
  'Valet',
  'Line Cook',
  'Prep Cook',
  'Dishwasher',
];
